<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Modalidade de Atendimento
        </div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px" justificarItem="between">
      <unicom-coluna sm="6" :class="espacamentoMobile">
        <Multiselect
          v-model="servicos"
          :propsMultiselect="{
            placeholder: 'Selecione as modalidades de atendimento',
            options: listaServicos,
            'track-by': 'id',
            label: 'tipoServico'
          }"
          :errorMessage="mensagemDeErroServicos.servicos"
        />
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile" v-if="outrosServicos">
        <div align="right" style="font-size: 17px; padding-top: 8px">
          Outros:
        </div>
      </unicom-coluna>
      <unicom-coluna sm="5" :class="espacamentoMobile" v-if="outrosServicos">
        <unicom-campo-texto
          :icone="campoOutros ? 'x' : ''"
          ladoIcone="direito"
          :maxCaracteres="1500"
          clickIcone
          @click-icone="campoOutros = ''"
          colorPlaceholder="#9E9E9E"
          placeholder="Outros"
          v-model="campoOutros"
          :mensagemErro="errorsServicos.campoOutrosServicos"
        />
      </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import ServicosMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/ServicosMixin";
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
// import CustomCampoTexto from "@/views/RecursosPropriosQuestionarios/shared/CampoTexto/CampoTexto.vue";

export default {
  name: "CartaoInformacoesServicos",
  mixins: [ServicosMixin],
  components: {
    Multiselect
    // CustomCampoTexto
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  }
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
